export enum MapWsEvents {
  GetCurrentMap = 'get_current_map'
}
